(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer-r2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header-r2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutricore-golf-product"]) return;
  try {
    
if (!customElements.get('ncg-product')) {
  customElements.define('ncg-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.classList.add('ncg-ready');
      this.panels = [...this.querySelectorAll('[data-gallery-panel]')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-button]')];
      this.variantSelect = this.querySelector('[data-variant-select]');
      const variantField = this.querySelector('[data-variant-field]');
      if (variantField) variantField.hidden = false;
      this.firstImage = this.panels[0]?.querySelector('img');
      this.firstThumbImage = this.thumbs[0]?.querySelector('img');
      this.thumbs.forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.galleryButton), { signal }));
      this.variantSelect?.addEventListener('change', () => this.updateVariant(), { signal });
      this.querySelectorAll('a[href^="#NcgPurchase-"]').forEach(link => link.addEventListener('click', () => {
        requestAnimationFrame(() => this.querySelector('[data-add]')?.focus({ preventScroll: true }));
      }, { signal }));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.transition?.skipTransition();
    }
    showImage(index) {
      const update = () => {
        this.panels.forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== String(index); });
        this.thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryButton === String(index))));
      };
      this.transition?.skipTransition();
      if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.transition = document.startViewTransition(update);
      } else {
        update();
      }
    }
    updateVariant() {
      const option = this.variantSelect.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      this.querySelector('[data-price]').textContent = option.dataset.price;
      this.querySelector('[data-compare]').textContent = option.dataset.compare;
      this.querySelector('[data-compare-wrap]').hidden = option.dataset.sale !== 'true';
      this.querySelector('[data-add]').disabled = !available;
      this.querySelector('[data-add-text]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
      this.querySelector('[data-availability]').textContent = available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
      const quantity = this.querySelector('[data-quantity]');
      const minimum = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      quantity.min = minimum;
      quantity.step = step;
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      let value = Math.max(minimum, Number(quantity.value) || minimum);
      if (option.dataset.max) value = Math.min(value, Number(option.dataset.max));
      value = minimum + Math.floor((value - minimum) / step) * step;
      quantity.value = value;
      if (this.firstImage) {
        this.firstImage.removeAttribute('srcset');
        if (option.dataset.image) {
          this.firstImage.src = option.dataset.image;
          this.firstImage.alt = option.dataset.imageAlt || this.dataset.fallbackAlt;
          if (this.firstThumbImage) { this.firstThumbImage.removeAttribute('srcset'); this.firstThumbImage.src = option.dataset.image; }
        } else {
          this.firstImage.src = this.dataset.fallbackImage;
          this.firstImage.alt = this.dataset.fallbackAlt;
          if (this.firstThumbImage) { this.firstThumbImage.removeAttribute('srcset'); this.firstThumbImage.src = this.dataset.fallbackThumb; }
        }
        this.showImage('1');
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    }
  });
}
if (!customElements.get('ncg-cross-sells')) {
  customElements.define('ncg-cross-sells', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('.ncg-cross-sells__form').forEach(form => {
        const input = form.querySelector('input[name="quantity"]');
        const decrease = form.querySelector('[data-cross-sell-step="-1"]');
        const increase = form.querySelector('[data-cross-sell-step="1"]');
        if (!input || !decrease || !increase) return;
        const sync = () => {
          const value = input.valueAsNumber;
          const min = Number(input.min || 1);
          const max = input.max === '' ? Infinity : Number(input.max);
          decrease.disabled = input.disabled || !Number.isFinite(value) || value <= min;
          increase.disabled = input.disabled || !Number.isFinite(value) || value >= max;
        };
        [decrease, increase].forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            if (button.disabled) return;
            if (button.dataset.crossSellStep === '1') input.stepUp();
            else input.stepDown();
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        input.addEventListener('input', sync);
        input.addEventListener('change', sync);
        sync();
      });
    }
  });
}

if (!customElements.get('ncg-purchase-extras')) {
  customElements.define('ncg-purchase-extras', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.status = this.querySelector('[data-stock-status]');
      this.statusText = this.querySelector('[data-stock-text]');
      this.mainForm = document.getElementById(this.dataset.formId);
      try {
        this.variants = JSON.parse(this.querySelector('[data-stock-variants]')?.textContent || '{}');
      } catch {
        this.variants = {};
      }
      if (!this.status || !this.statusText || !this.mainForm) return;
      this.variantSelect = this.mainForm.querySelector('[data-variant-select]');
      this.variantSelect?.addEventListener('change', () => this.renderStock(this.variantSelect.value), { signal });
      this.renderStock(this.variantSelect?.value || this.dataset.currentVariant);

      // Kaching owns bundle selection and submission. Only observe its public events.
      this.observedWidgets = new WeakSet();
      const observeWidgets = () => {
        this.mainForm.querySelectorAll('kaching-bundles-block, kaching-bundle').forEach(widget => {
          if (this.observedWidgets.has(widget)) return;
          this.observedWidgets.add(widget);
          ['variant-selected', 'variants-changed'].forEach(eventName => {
            widget.addEventListener(eventName, event => this.onBundleVariantChange(event), { signal });
          });
        });
      };
      observeWidgets();
      this.observer = new MutationObserver(observeWidgets);
      this.observer.observe(this.mainForm, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    stockState(variant) {
      if (!variant || typeof variant.available !== 'boolean') return 'unknown';
      if (!variant.available) return 'sold-out';
      if (variant.tracked === true && Number.isFinite(variant.quantity) && variant.quantity > 0 && variant.quantity <= 10) return 'limited';
      return 'available';
    }

    renderStock(variantId) {
      const variant = this.variants[String(variantId)];
      const state = this.stockState(variant);
      this.status.hidden = state === 'unknown';
      if (state === 'unknown') return;
      this.status.dataset.state = state;
      this.statusText.textContent = state === 'limited'
        ? this.dataset.stockLimited.replace('[quantity]', String(variant.quantity))
        : state === 'sold-out' ? this.dataset.stockSoldOut : this.dataset.stockAvailable;
    }

    onBundleVariantChange(event) {
      const productVariantIds = Object.keys(this.variants);
      // The label describes this trainer, not other products in a complete bundle.
      if (productVariantIds.length === 1) {
        this.renderStock(productVariantIds[0]);
        return;
      }
      const detail = event.detail || {};
      const selections = Array.isArray(detail.variantIdQuantities) ? detail.variantIdQuantities : [detail];
      const selectedIds = [...new Set(selections.map(selection => String(selection?.variantId ?? '')).filter(id => this.variants[id]))];
      if (selectedIds.length === 1) this.renderStock(selectedIds[0]);
      else this.status.hidden = true;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
